var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWidget = function SvgWidget(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 20,
    fill: "none",
    viewBox: "0 0 17 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.58 6.84a.93.93 0 0 1 0-1.17l3.6-4.55a1.06 1.06 0 0 1 1.65 0l3.58 4.56c.27.34.27.81 0 1.15l-3.58 4.55c-.4.53-1.23.53-1.65 0l-3.6-4.54Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M12.52 10.56v5.76a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V7.84c0-1.1.9-2 2-2h5.8",
    vectorEffect: "non-scaling-stroke"
  })));
};
export default SvgWidget;